import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	formContainer: {
		flexGrow: 1,
		display: "flex",
		flexDirection: "column",
	},
}));
